// import last from "lodash/last";
import { Cloudinary } from "@cloudinary/url-gen";
import { autoGravity } from "@cloudinary/url-gen/qualifiers/gravity";

// Import required actions.
import { fill } from "@cloudinary/url-gen/actions/resize";
import { useRootStore } from "@/stores/root";

export const useCdn = () => {
  // Create a Cloudinary instance and set your cloud name.
  const cld = new Cloudinary({
    cloud: {
      cloudName: "thinkingabout-srl",
    },
    url: {
      secure: true, // force https, set to false to force http
      analytics: false, // enable usage of Cloudinary's analytics capabilities
    },
  });

  const rootStore = useRootStore();

  function fromCloudinary(url, params) {
    if (!url) {
      return "";
    }

    // EXTRACT ID FROM URL
    const last = (arr) => arr[arr.length - 1];
    let id = last(url.split("/"));
    id = id.replace(/(.*)\..*/, "$1");

    // Create a transformation.
    // fill: cropping method to generate and deliver an image that completely fills the requested size while retaining the original aspect ratio
    // https://cloudinary.com/documentation/resizing_and_cropping
    const resizeAction = fill();

    // regexp is a video
    if (url.match(/.*\.(mp4|webm|ogv)/) || /\/video\//.test(url)) {
      // Instantiate a CloudinaryImage object for the image with public ID, 'front_face'.
      const myVideo = cld.video(`${rootStore.cdnFolder}/${id}`);
      if (
        /^auto$|^auto:best$|^auto:good$|^auto:eco$|^auto:low$/.test(
          params?.quality
        )
      ) {
        myVideo.quality(params.quality);
      } else if (params?.quality) {
        console.warn("Error: quality must be auto or auto:best|good|eco|low");
      }
      resizeAction.width(params?.width || 1920);
      myVideo.resize(resizeAction);
      return myVideo.toURL();
    }

    // Instantiate a CloudinaryImage object for the image with public ID, 'front_face'.
    const myImage = cld.image(`${rootStore.cdnFolder}/${id}`);

    let format = params?.attachment
      ? "jpg"
      : rootStore.avif && params?.width && params.width < 3000
      ? "avif"
      : "auto";

    // let format = "jpg";

    if (params?.width) {
      resizeAction.width(params.width);
    }

    if (params?.height) {
      resizeAction.height(params.height);
    }

    if (params?.autoGravity) {
      resizeAction.gravity(autoGravity());
    }

    // Perform the transformation.
    myImage
      .resize(resizeAction)
      .quality(params?.quality ? params.quality : "auto:eco")
      .format(format);

    return myImage.toURL();
  }

  return {
    fromCloudinary,
  };
};
